import React from 'react'
import "../../styles/product.scss"

function Loading() {
    return (
        <div className="lds-dual-ring_container">
            <div className="lds-dual-ring"></div>
        </div>
    )
}

export default Loading
